import { translate } from './TranslationService';
const TooltipAttribute = 'content-tooltip';
const generateTemplate = (attName: string) => `
<span class="ccm-tooltip">
  {{tooltip-${attName}-title}}
     <span class="ccm-tooltiptext">
        {{tooltip-${attName}-text}}
     </span>
</span>`;

class TooltipView {
  public enhanceView (element: Document): void {
    const elements = element.querySelectorAll(`[content-tooltip]`);
    const tooltips = Array.prototype.slice.call(elements); 
    for(const tooltip of tooltips){
      const attName =tooltip.getAttribute(`${TooltipAttribute}`);
      let template = generateTemplate(attName);
      template = translate(template);
      const parser = new DOMParser();
      const html = parser.parseFromString(template, 'text/html');

      tooltip.appendChild(html.body.firstChild);
    }
  }
}

export { TooltipView };
